export interface TMessage {
  token?: string | undefined;
  refreshToken?: string | undefined;
  state?: string | undefined;
  authType: "login" | "logout";
}

export function getURLParameter(name: string) {
  const param = new URLSearchParams(location.search).get(name);
  if (param) return param.replace(/^"(.*)"$/, "$1");
  return param;
}

export function getCSRFToken() {
  const randomString = crypto.getRandomValues(new Uint32Array(1)).toString();

  const loginBufferMinutes = 2;
  const expiry = Date.now() + loginBufferMinutes * (60 * 1000);

  const token = btoa(`${randomString}:${expiry}`);

  return token;
}

export function storeTokens(data: TMessage) {
  try {
    const { token, refreshToken } = data;

    if (refreshToken) localStorage.setItem("refreshToken", refreshToken);
    if (token) {
      sessionStorage.setItem("token", token);

      const tokenDetails = JSON.parse(atob(token.split(".")[1]));
      localStorage.setItem("username", tokenDetails.name || tokenDetails.preferred_username);
      localStorage.setItem("useremail", tokenDetails.email || tokenDetails.preferred_username);
    }
  } catch (err) {
    console.error(err);
  }
}

export function handleVerifyUserError(statusCode: number) {
  let error = "servererror";
  switch (statusCode) {
    case 401:
    case 403:
      error = "noaccess";
      break;
    case 404:
      error = "invalidteam";
      break;
    case 424:
      error = "requiredmfa";
      break;
    default:
      error = "servererror";
      break;
  }

  return error;
}
